export default __webpack_public_path__ + "static/media/host_groupchat_me.2adad4bd.svg";